import { AcceleratorDocMetadata } from "../models/AcceleratorDocMetadata";
import { DocumentStatus } from "../types/DocumentStatuses";
import { DocumentStatusBubble } from "./bubbles/DocumentStatusBubble";
import "../styles/documentMetadata.css";
import { ViewableDateLong } from "../models/ViewableDate";

export { DocumentMetadata };

type Props = {
  acceleratorDocMetadata?: AcceleratorDocMetadata;
  batchClassId: string;
  debugView: boolean;
};

const DocumentMetadata = (props: Props) => {
  if (!props.acceleratorDocMetadata) {
    return <span></span>;
  }
  const metadata = props.acceleratorDocMetadata;
  const showDocStatus: boolean =
    (metadata.statuses ?? []).filter((x) => x ?? "" === "").length > 0;
  return (
    <div className={"documentMetadata"}>
      <div className={"batchData"}>
        <span>
          <strong>Batch Class:</strong> {props.batchClassId}
        </span>
        <span>
          <strong>Batch Instance:</strong> {metadata.batchInstanceId}
        </span>
        <span>
          <strong>Document ID:</strong> {metadata.storeId.docId}
        </span>

        {props.debugView && (
          <>
            <span>
              <strong>Batch UUID:</strong> {metadata.storeId.batchInstanceUuid}
            </span>
            <span>
              <strong>Doc UUID:</strong> {metadata.uuid}
            </span>
          </>
        )}
      </div>

      <div className={"documentData"}>
        <span>
          <strong>Document Type:</strong> {metadata.classifiedDocType}
        </span>
        <span>
          <strong>Template Name:</strong> {metadata.classifiedModelName}
        </span>
        <span>
          <strong>Pages:</strong> {metadata.pageCount}
        </span>
      </div>

      {showDocStatus && (
        <div className={"documentStatuses"}>
          <strong>Document Status:</strong>
          {metadata.statuses?.map((x: DocumentStatus) => (
            <DocumentStatusBubble key={x} status={x} />
          ))}
        </div>
      )}
    </div>
  );
};
